module.exports = __webpack_public_path__ + "static/media/WAHAROA 3.44677acc.JPG";